import { TriangleAlert } from 'lucide-react'

import { cn } from '@/utils'

interface SecuritiesFailedStateProps {
  // 'panel' is the full Portfolio tab state; 'card' is the compact Overview card row.
  layout: 'panel' | 'card'
}

export const SecuritiesFailedState = ({
  layout,
}: SecuritiesFailedStateProps) => (
  <div
    className={cn(
      'flex items-center gap-3',
      layout === 'panel'
        ? 'flex-col rounded-lg border bg-white p-10 text-center'
        : 'py-1',
    )}
  >
    <TriangleAlert
      className="size-5 shrink-0 text-amber-700"
      strokeWidth={1.75}
    />
    <div className="min-w-0 space-y-0.5">
      <p className="text-sm font-semibold text-blue-7">
        Couldn't read the brokerage statements
      </p>
      <p className="text-sm text-ink-subtle">
        The system couldn't read holdings from these statements. Contact support
        and we'll look into it.
      </p>
    </div>
  </div>
)
